<div [formGroup]="form">
  <div class="tw-grid tw-grid-cols-2 tw-gap-4 tw-mt-5">

    <!-- @if(listingTypeId === itemListingTypeEnum.Custom){ -->
      <!-- <div class="sml-control-group tw-col-span-2">
      <label for="online-payment" class="sml-label">Accept Online Payment <sup class="tw-text-alert-800">*</sup></label>

      <sml-radio-button [options]="booleanEnum" [customClass]="'tw-grid-cols-2'" [disabledOptions]="disabledOption" formControlName="onlinePayment" groupIdentifier="online-payment" 
      ></sml-radio-button>
      <div *ngIf="control['onlinePayment'].touched && control['onlinePayment'].errors?.['required']" class="tw-text-alert-800 sml-form-error">
        <i-icon [name]="'info'" class="!tw-w-3 !tw-h-3"></i-icon> <span> This field is mandatory.</span>
      </div>
    </div> -->
   
      <!-- <div class="sml-control-group tw-col-span-2 tablet:tw-col-span-1">
        <label for="price" class="sml-label">Donation Amounts <sup class="tw-text-alert-800">*</sup></label>
        <label for="customMinPrice" class="tw-relative tw-w-full tw-block">
          <i-icon [name]="'dollar'" class="tw-w-5 tw-h-5 tw-text-mercury-600 tw-absolute tw-top-3 tw-left-1"></i-icon>
          <input type="number" min="0" id="customMinPrice" formControlName="customMinPrice" placeholder="Min Donation" class="sml-control !tw-pl-8" smlInputNumber
            [ngClass]="{'sml-control-error': control['customMinPrice'].invalid && (control['customMinPrice'].dirty || control['customMinPrice'].touched)}" />
        </label>
        <div *ngIf="control['customMinPrice'].touched && control['customMinPrice'].errors?.['required']" class="tw-text-alert-800 sml-form-error">
          Min donation is required
        </div>
        <div *ngIf="control['customMinPrice'].touched && control['customMinPrice'].errors?.['min']" class="tw-text-alert-800 sml-form-error">
          Min donation cannot be less than 1
        </div>
      </div>
      <div class="sml-control-group tw-col-span-2 tablet:tw-col-span-1">
        <label *ngIf="!isMobileView" for="price" class="sml-label">&nbsp;</label>
        <label for="customMaxPrice" class="tw-relative tw-w-full tw-block">
          <i-icon [name]="'dollar'" class="tw-w-5 tw-h-5 tw-text-mercury-600 tw-absolute tw-top-3 tw-left-1"></i-icon>
          <input type="number" min="0" id="customMaxPrice" formControlName="customMaxPrice" placeholder="Max Donation" class="sml-control !tw-pl-8" smlInputNumber
            [ngClass]="{'sml-control-error': (control['customMaxPrice'].invalid || form.errors?.['invalidPriceRange']) && (control['customMaxPrice'].dirty || control['customMaxPrice'].touched)}" />
        </label>
        @if(control['customMaxPrice'].touched && control['customMaxPrice'].errors?.['required']){
          <div class="tw-text-alert-800 sml-form-error">
            Max donation is required
          </div>
        }
        @else if(control['customMaxPrice'].touched && control['customMaxPrice'].errors?.['min']){
          <div class="tw-text-alert-800 sml-form-error">
            Max donation cannot be less than 1
          </div>
        }
        @else if(control['customMaxPrice'].touched && form.errors?.['invalidPriceRange']){
          <div class="tw-text-alert-800 sml-form-error">
            Max donation must be greater than min donation
          </div>
        }
      </div> -->
    <!-- } -->
    @if(!isVolunteerActivity){
      <div class="sml-control-group tw-col-span-2 tablet:tw-col-span-1" *ngIf="listingTypeId !== itemListingTypeEnum.Multiple && listingTypeId !== itemListingTypeEnum.Custom"
      >
        <label for="price" class="sml-label">Price Per Item <sup *ngIf="showPricePerItem"  class="tw-text-alert-800">*</sup></label>
        <label for="priceInput" class="tw-relative tw-w-full tw-block">
          <i-icon [name]="'dollar'" class="tw-w-5 tw-h-5 tw-text-mercury-600 tw-absolute tw-top-3 tw-left-1"></i-icon>
          <input type="number" min="0" id="priceInput" formControlName="price" placeholder="Enter" class="sml-control !tw-pl-8" smlInputNumber
            [ngClass]="{'sml-control-error': control['price'].invalid && (control['price'].dirty || control['price'].touched)}" />
      
        </label>
    
        <div *ngIf="control['price'].touched && control['price'].errors?.['required']" class="tw-text-alert-800 sml-form-error">
          Price is required
        </div>
        <div *ngIf="control['price'].touched && control['price'].errors?.['min']" class="tw-text-alert-800 sml-form-error">
          Price cannot be less than 1
        </div>
      </div>
      <!-- <div class="sml-control-group" [ngClass]="{'tw-col-span-2':listingTypeId === itemListingTypeEnum.Multiple,
        'tw-col-span-1 max-md:tw-col-span-2': listingTypeId !== itemListingTypeEnum.Multiple
      }" >
        <label for="online-payment" class="sml-label">Accept Online Payment <sup class="tw-text-alert-800">*</sup></label>

        <sml-radio-button [options]="booleanEnum" [customClass]="'tw-grid-cols-2'" formControlName="onlinePayment" groupIdentifier="online-payment" 
        ></sml-radio-button>
        <div *ngIf="control['onlinePayment'].touched && control['onlinePayment'].errors?.['required']" class="tw-text-alert-800 sml-form-error">
          <i-icon [name]="'info'" class="!tw-w-3 !tw-h-3"></i-icon> <span> This field is mandatory.</span>
        </div>
      </div> -->
      <div class="tw-flex tw-items-center tw-gap-[10px] tw-col-span-2">
        <div class="tw-font-bold tw-text-sm tw-text-[#041519]">
          {{getFieldName()}} <sup class="tw-text-alert-800">*</sup>
        </div>
        <div
              class="tw-flex tw-border-mercury-200"
             
            >
              <sml-tabs
                [tabs]="sections"
                [activeTab]="currentTab"
                [variation]="'filled'"
                [customclassesForTab]="true"
                (activeTabChange)="activeSection($event)"
              ></sml-tabs>
            </div>
      </div>
    }
    


    <div class="sml-control-group tw-col-span-2 tw-grid tw-grid-cols-2 tw-gap-4" *ngIf="listingTypeId === itemListingTypeEnum.Multiple || listingTypeId === itemListingTypeEnum.Custom">
      @if(currentTab==='Set Price'){
      <div class="sml-control-group max-md:tw-col-span-2" *ngIf="!isVolunteerActivity">
     
        <label for="priceInput" class="tw-relative tw-w-full tw-block">
          <i-icon [name]="'dollar'" class="tw-w-5 tw-h-5 tw-text-mercury-600 tw-absolute tw-top-3 tw-left-1"></i-icon>
          <input type="number" min="0" id="priceInput" formControlName="price" placeholder="Enter" class="sml-control !tw-pl-8" smlInputNumber
            [ngClass]="{'sml-control-error': control['price'].invalid && (control['price'].dirty || control['price'].touched)}" />
        </label>
    
        <div *ngIf="control['price'].touched && control['price'].errors?.['required']" class="tw-text-alert-800 sml-form-error">
          Price is required
        </div>
        <div *ngIf="control['price'].touched && control['price'].errors?.['min']" class="tw-text-alert-800 sml-form-error">
          Price cannot be less than 1
        </div>
      </div>
    }
    @if(currentTab==='Price Range'){
   
      <div class="sml-control-group tw-col-span-2 tablet:tw-col-span-1">
        <label for="customMinPrice" class="tw-relative tw-w-full tw-block">
          <i-icon [name]="'dollar'" class="tw-w-5 tw-h-5 tw-text-mercury-600 tw-absolute tw-top-3 tw-left-1"></i-icon>
          <input type="number" min="0" id="customMinPrice" formControlName="customMinPrice" placeholder="Min Donation" class="sml-control !tw-pl-8" smlInputNumber
            [ngClass]="{'sml-control-error': control['customMinPrice'].invalid && (control['customMinPrice'].dirty || control['customMinPrice'].touched)}" />
        </label>
        <div *ngIf="control['customMinPrice'].touched && control['customMinPrice'].errors?.['required']" class="tw-text-alert-800 sml-form-error">
          Min donation is required
        </div>
        <div *ngIf="control['customMinPrice'].touched && control['customMinPrice'].errors?.['min']" class="tw-text-alert-800 sml-form-error">
          Min donation cannot be less than 1
        </div>
      </div>
      <div class="sml-control-group tw-col-span-2 tablet:tw-col-span-1">
        <label for="customMaxPrice" class="tw-relative tw-w-full tw-block">
          <i-icon [name]="'dollar'" class="tw-w-5 tw-h-5 tw-text-mercury-600 tw-absolute tw-top-3 tw-left-1"></i-icon>
          <input type="number" min="0" id="customMaxPrice" formControlName="customMaxPrice" placeholder="Max Donation" class="sml-control !tw-pl-8" smlInputNumber
            [ngClass]="{'sml-control-error': (control['customMaxPrice'].invalid || form.errors?.['invalidPriceRange']) && (control['customMaxPrice'].dirty || control['customMaxPrice'].touched)}" />
        </label>
        @if(control['customMaxPrice'].touched && control['customMaxPrice'].errors?.['required']){
          <div class="tw-text-alert-800 sml-form-error">
            Max donation is required
          </div>
        }
        @else if(control['customMaxPrice'].touched && control['customMaxPrice'].errors?.['min']){
          <div class="tw-text-alert-800 sml-form-error">
            Max donation cannot be less than 1
          </div>
        }
        @else if(control['customMaxPrice'].touched && form.errors?.['invalidPriceRange']){
          <div class="tw-text-alert-800 sml-form-error">
            Max donation must be greater than min donation
          </div>
        }
      </div>
    }
      <div class="sml-control-group tw-col-span-2" 
     *ngIf="isVolunteerActivity">
      <label for="payment-details" class="sml-new-label">Activity Type<sup class="tw-text-alert-800">*</sup></label> 
      <span class="tw-text-grey-950 "  [smlTooltip]="'Does your volunteer event have a single sign-up option or multiple shifts?'" [placement]="'bottom'" mode="always">
         <i-icon [name]="'info'" class="!tw-w-3 !tw-h-3" ></i-icon>
        </span>
       
      <sml-toggle-radio-button [options]="participationDetailEnum" [customClass]="'tw-grid-cols-2'" formControlName="hasVolunteerShifts" groupIdentifier="payment-details"  [disabledOptions]="shiftDisableOption"
      [combinedViewWithButton]="true"
      ></sml-toggle-radio-button>
      <div *ngIf="showShiftError" class="tw-text-alert-800 sml-form-error">
        <i-icon [name]="'info'" class="!tw-w-3 !tw-h-3"></i-icon> <span>Please add at least one shift</span>
      </div>
      <div *ngIf="control['hasVolunteerShifts'].touched && control['hasVolunteerShifts'].errors?.['required']" class="tw-text-alert-800 sml-form-error">
        <i-icon [name]="'info'" class="!tw-w-3 !tw-h-3"></i-icon> <span> This field is mandatory.</span>
      </div>
    </div>
      <div [ngClass]="{'tw-col-span-2': isVolunteerActivity && showTotalVolunteers==false,
        'max-md:tw-col-span-2':!isVolunteerActivity && currentTab==='Set Price'
      }">
   @if(isVolunteerActivity && showTotalVolunteers){
    <div class="tw-flex tw-flex-col tw-gap-1">

      @if (isEditItem) {
        <label for="price" class="sml-new-label">
          {{isVolunteerActivity ? "Total Volunteers Needed" : "Remaining Quantity"}}
          <sup  class="tw-text-alert-800">*</sup>
        </label>
        <!-- <label for="remainingQuantityInput" class="tw-relative tw-w-full tw-block"></label>
        <i-icon [name]="'dollar'" class="tw-w-5 tw-h-5 tw-text-mercury-600 tw-absolute tw-top-3 tw-left-1"></i-icon> -->
        <input type="number" min="0" id="remainingQuantityInput" formControlName="remainingQuantity" placeholder="Enter Quantity" class="sml-control" smlInputNumber
        [ngClass]="{'sml-control-error': control['remainingQuantity'].invalid && (control['remainingQuantity'].dirty || control['remainingQuantity'].touched)}" />
        <div *ngIf="control['remainingQuantity'].touched && control['remainingQuantity'].errors?.['required']" class="tw-text-alert-800 sml-form-error">
          {{isVolunteerActivity ? "Total Volunteers Needed" : "Remaining Quantity"}} is required
        </div>
        <div *ngIf="control['remainingQuantity'].touched && control['remainingQuantity'].errors?.['min']" class="tw-text-alert-800 sml-form-error">
          {{isVolunteerActivity ? "Total Volunteers Needed" : "Remaining Quantity"}} cannot be less than 1
        </div>
      }
      @else {
        <label for="price" class="sml-new-label">
          {{isVolunteerActivity ? "Total Volunteers Needed" : "Quantity"}}
          <sup class="tw-text-alert-800">*</sup>
        </label>
        <!-- <label for="quantityInput" class="tw-relative tw-w-full tw-block"></label>
        <i-icon [name]="'dollar'" class="tw-w-5 tw-h-5 tw-text-mercury-600 tw-absolute tw-top-3 tw-left-1"></i-icon> -->
        <input type="number" min="0" id="quantityInput" formControlName="quantity" placeholder="Enter Quantity" class="sml-control" smlInputNumber
          [ngClass]="{'sml-control-error': control['quantity'].invalid && (control['quantity'].dirty || control['quantity'].touched)}" />
        <div *ngIf="control['quantity'].touched && control['quantity'].errors?.['required']" class="tw-text-alert-800 sml-form-error">
          {{isVolunteerActivity ? "Total Volunteers Needed" : "Quantity"}} is required
        </div>
        <div *ngIf="control['quantity'].touched && control['quantity'].errors?.['min']" class="tw-text-alert-800 sml-form-error">
          {{isVolunteerActivity ? "Total Volunteers Needed" : "Quantity"}} cannot be less than 1
        </div>
      }
      <div class="tw-flex tw-gap-1 tw-items-center">
        <input type="checkbox" 
               class="!tw-h-[18px] !tw-w-[18px]"
               formControlName="isUnlimitedParticipation"
               (change)="onUnlimitedParticipationChange($event)"/>
        <div class="tw-text-[#828485] tw-text-xs tw-font-medium">
          Unlimited quantity?
        </div>
      </div>
    </div>

    }
    @else if(isVolunteerActivity && showTotalVolunteers==false){

        <sml-item-participation-details 
          [contacts]="VolunteerData" 
          (shiftsChange)="onVolunteerShiftsChange($event)"
          [drawerSize]="drawerSize"
          [isMobile]="isMobileView"
          [isNewFlag]="isNewFlag">
        </sml-item-participation-details>
      
        
    }
    
    @else if(!isVolunteerActivity && currentTab==='Set Price') {
      <div class="tw-flex tw-flex-col tw-gap-1">
      @if (isEditItem) {
        
        <input type="number" min="0" id="remaningQuantityInput" formControlName="remainingQuantity" placeholder="Enter Quantity" class="sml-control" smlInputNumber
        [ngClass]="{'sml-control-error': control['remainingQuantity'].invalid && (control['remainingQuantity'].dirty || control['remainingQuantity'].touched)}" />
        <div *ngIf="control['remainingQuantity'].touched && control['remainingQuantity'].errors?.['required']" class="tw-text-alert-800 sml-form-error">
          {{isVolunteerActivity ? "Total Volunteers Needed" : "Remaining Quantity"}} is required
        </div>
        <div *ngIf="control['remainingQuantity'].touched && control['remainingQuantity'].errors?.['min']" class="tw-text-alert-800 sml-form-error">
          {{isVolunteerActivity ? "Total Volunteers Needed" : "Remaining Quantity"}} cannot be less than 1
        </div>
                  
      }
      @else {
        
        <input type="number" min="0" id="quantityInput" formControlName="quantity" placeholder="Enter Quantity" class="sml-control" smlInputNumber
          [ngClass]="{'sml-control-error': control['quantity'].invalid && (control['quantity'].dirty || control['quantity'].touched)}" />
        <div *ngIf="control['quantity'].touched && control['quantity'].errors?.['required']" class="tw-text-alert-800 sml-form-error">
          {{isVolunteerActivity ? "Total Volunteers Needed" : "Quantity"}} is required
        </div>
        <div *ngIf="control['quantity'].touched && control['quantity'].errors?.['min']" class="tw-text-alert-800 sml-form-error">
          {{isVolunteerActivity ? "Total Volunteers Needed" : "Quantity"}} cannot be less than 1
        </div>

      }
      <div class="tw-flex tw-gap-1 tw-items-center">
        <input type="checkbox" 
               class="!tw-h-[18px] !tw-w-[18px]"
               formControlName="isUnlimitedParticipation"
               (change)="onUnlimitedParticipationChange($event)"/>
        <div class="tw-text-[#828485] tw-text-xs tw-font-medium">
          Unlimited quantity?
        </div>
      </div>
    </div>

    }
  
    </div>
    </div>
    @if(!isVolunteerActivity && campaignType!==campaignTypeEnum['Interactive Tour']){
      <div class="tw-flex tw-mt-6  max-md:tw-col-span-2">
        <div class="tw-flex tw-flex-col tw-gap-[5px]">
          <div class="tw-flex tw-gap-5">
            <sml-toggle-button formControlName="onlinePayment"
            groupidentifier="onlinePayment"></sml-toggle-button>
          <div class="tw-text-sm tw-font-bold">
            <div class="tw-flex tw-items-center tw-gap-1">
              <div>
                Accept Online Payment
              </div>
              <i-icon [name]="'info'" class="!tw-w-4 !tw-h-4" [smlTooltip]="'Enabling online payment will allow your participants to pay conveniently online.'" [placement]="'bottom'" mode="always"></i-icon>
            </div>
            
          </div>
          </div>
          <div class="tw-text-xs tw-font-medium tw-text-[#828485]">
            Collect payments through SeeMyLegacy
          </div>
    
      </div>
      
    </div>
    }
    <!-- <div class="sml-control-group tw-col-span-2">
      <label for="participationMethod" class="sml-label !tw-mb-0">Participation Method <sup class="tw-text-alert-800">*</sup></label>
      <p class="tw-text-grey-600 tw-text-sm tw-font-normal tw-leading-snug">
        Choose how you want community members to participate in this Campaign Item
      </p>

      <div class="tw-relative tw-mt-4" (smlClickOutside)="hideParticipationDropdown()">
        <button type="button" class="tw-h-12 tw-p-3 tw-w-full tw-bg-white tw-rounded-lg tw-border tw-border-mercury-200 tw-justify-between tw-items-center tw-gap-2 tw-flex disabled:tw-text-[#828485] disabled:tw-bg-[#F8F8F8] disabled:tw-cursor-not-allowed"
          (click)="toggleParticipationDropdown()"
          [disabled]="listingTypeId === itemListingTypeEnum.Custom"
          [ngClass]="{'sml-control-error': control['participationMethod'].invalid && (control['participationMethod'].dirty || control['participationMethod'].touched)}">
          <span class="tw-black tw-text-sm tw-font-medium tw-leading-tight tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis" [smlTooltip]="getSelectedOption()"
          [ngClass]="{'!tw-text-mercury-600': !control['participationMethod'].value}">{{getSelectedOption()}}</span>
          <i-icon [name]="'chevron-down'" [height]="'tw-h-4'" [width]="'tw-w-4'" class="tw-text-mercury-600 tw-flex-grow-0 tw-flex-shrink-0 tw-basis-4"></i-icon>
        </button>
        @if(showParticipationDropdown){
        <ul class="tw-absolute tw-top-full tw-left-0 tw-w-full tw-py-1 tw-bg-white tw-border tw-border-mercury-200 tw-rounded-xl tw-shadow tw-z-10">
          @for (item of participationOptions; track item.id) {
          <li>
            <label class="tw-block tw-w-full group">
              <input type="radio"  name="participationMethod" [value]="item.id" class="tw-absolute tw-opacity-0 tw-invisible"
                (change)="handleParticipationChange(item)">
              <div class="tw-flex tw-items-start tw-gap-2 tw-cursor-pointer tw-py-2.5 tw-px-3 tw-transition-all hover:tw-bg-mercury-100"
              [ngClass]="{
                'tw-cursor-not-allowed': item.id === participationMethods.CustomForm && !isAllowCustomFormSelection,
                'tw-cursor-pointer': !(item.id === participationMethods.CustomForm && !isAllowCustomFormSelection)
              }">
                <i-icon [name]="item.icon" [height]="'tw-h-4'" [width]="'tw-w-4'" class="tw-text-mercury-600"></i-icon>
                <div>
                  <h5 class="tw-text-black tw-leading-none tw-font-medium tw-text-sm tw-mb-1.5"
                  [ngClass]="{'!tw-text-mercury-600': item.id === participationMethods.CustomForm && !isAllowCustomFormSelection}">{{item.title}}</h5>
                  <p class="tw-text-mercury-950 tw-text-xs tw-font-normal tw-leading-snug"
                  [ngClass]="{'!tw-text-mercury-600': item.id === participationMethods.CustomForm && !isAllowCustomFormSelection}">{{item.subtitle}}</p>
                </div>
              </div>
            </label>
          </li>
          }
        </ul>
        }
      </div>
      <div *ngIf="control['participationMethod'].touched && control['participationMethod'].errors?.['required']" class="tw-text-alert-800 sml-form-error">
        Participation Method is required
      </div>
    </div> -->
  </div>

</div>
<!-- <div class="tw-font-medium tw-text-sm tw-leading-[22px] tablet:tw-text-base tw-text-mercury-950 tw-pt-5">
  If you would like to collect more detailed information from your participants,
  contact our Support Team to request a Custom Form 👉🏼
  <a href="{{supportUrl}}" target="_blank" class="tw-font-bold tw-text-primary-700 tw-cursor-pointer">
    Contact support.
  </a>
</div> -->
